import { GOOGLE_FAVICONS_API_URL } from '~/constants';

export const getWebLinkFaviconImg = (url: string, size?: number) =>
  `${GOOGLE_FAVICONS_API_URL}?domain=${url}&sz=${size ?? 32}`;

export const getValidUrl = (url: string) => {
  let validUrl;
  try {
    validUrl = new URL(url);
    if (!validUrl.hostname) {
      validUrl = new URL(`https://${url}`);
    }
  } catch (error) {
    validUrl = new URL(`https://${url}`);
  }
  return validUrl.toString();
};
